// extracted by mini-css-extract-plugin
module.exports = {"HeroCTA":"HeroCTA_HeroCTA__sEhEg","Hero-Text":"HeroCTA_Hero-Text__1clVV","Hero-Desc":"HeroCTA_Hero-Desc__2pTNm"};